<template>
  <transition name="fade">
    <div class="search-tip" v-if="show" :class="extraClass">
      <div class="search-content">
        <div
          class="search-box"
          v-for="(category, key) in tipContent"
          :key="key"
        >
          <template v-if="category.length">
            <div class="search-hd">
              {{ $t(`searchInput.${key}`) }}
            </div>
            <div
              class="search-bd"
              v-for="(item, index) in category"
              :key="index"
              @click="goDetail(key, item)"
              :class="{ token: key === 'token' || key === 'contract' }"
            >
              <template v-if="key === 'token'">
                <img :src="item.logo" width="24" height="24" v-if="item.logo" />
                <span v-else class="token-no-logo">{{ renderLogo(item) }}</span>
                <span class="f-b">
                  {{ renderName(item) }}
                </span>
                <span class="hash">{{ item.contract_hash }}</span>
              </template>
              <template v-else-if="key === 'contract'">
                <span class="f-b">{{ item.name }}</span>
                <span class="hash">{{ item.contract_hash }}</span>
              </template>
              <template v-else>
                {{ item }}
              </template>
            </div>
          </template>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import axios from "axios";
import $httpService from "../../common/utils";
import debounce from "lodash.debounce";

export default {
  data() {
    return {
      show: false,
      tipContent: {
        token: [],
        ontId: [],
        contract: [],
        address: [],
        transaction: [],
        blockHeight: []
      },
      requests: [],
      request: null
    };
  },
  props: {
    content: {
      type: String
    },
    extraClass: {
      type: String
    },
    focused: {
      type: Boolean
    }
  },
  watch: {
    content: function(...args) {
      this.debouncedWatch(...args);
    },
    focused: function(val) {
      if (!val) {
        this.cancel();
        this.clear();
      } else {
        this.query(this.content);
      }
    }
  },
  methods: {
    renderLogo(item) {
      return item.name
        ? item.name.substr(0, 2)
        : item.symbol
        ? item.symbol.substr(0, 2)
        : "C";
    },

    renderName(item) {
      if (item.name && item.symbol) {
        return `${item.name} (${item.symbol})`;
      }
      return item.name || item.symbol;
    },

    cancel() {
      if (this.request) {
        this.request.cancel();
        this.clearOldRequest("Cancelled");
      }
    },

    logResponseErrors(err) {
      if (axios.isCancel(err)) {
        console.log("Request cancelled");
      }
    },

    clearOldRequest(msg) {
      this.request.msg = msg;
      this.requests.push(this.request);
      this.request = null;
    },

    clear() {
      this.show = false;
      this.tipContent = {
        token: [],
        ontId: [],
        contract: [],
        address: [],
        transaction: [],
        blockHeight: []
      };
    },

    async query(val) {
      this.cancel();
      const less2char = val.length < 2;
      if (less2char) {
        this.clear();
      }
      if (less2char || !this.focused) {
        return;
      }
      const { net } = this.$route.params;
      const axiosSource = axios.CancelToken.source();
      this.request = { cancel: axiosSource.cancel, msg: "Loading..." };
      const apiPrefix =
        net === "testnet"
          ? process.env.TEST_EXPLORE_URL
          : process.env.EXPLORE_URL;

      try {
        const { code, result } = await $httpService.get(
          `${apiPrefix}v2/contracts/check_type/${val}`,
          {
            cancelToken: axiosSource.token
          }
        );
        this.clearOldRequest("Success");
        if (!this.focused) {
          return;
        }
        if (code === 0) {
          this.genContent(result);
        } else {
          this.clear();
        }
      } catch (error) {
        this.logResponseErrors(error);
        this.clear();
      }
    },
    genContent(result) {
      const res = {
        token: [],
        ontId: [],
        contract: [],
        address: [],
        transaction: [],
        blockHeight: []
      };
      let flag = false;
      for (let i = 0; i < result.length; i++) {
        const item = result[i];
        flag = true;
        if (item.category == "contract" || item.category == "token") {
          res[item.category].push(item.contract_info);
        } else {
          res[this.$HelperTools.camelize(item.category)].push(this.content);
        }
      }
      this.tipContent = res;
      if (flag) {
        this.show = true;
      }
    },
    goDetail(key, item) {
      const { net } = this.$route.params;
      const pathMap = {
        token: "TokenDetail",
        ontId: "OntIdDetail",
        contract: "ContractDetail",
        address: "AddressDetail",
        transaction: "TransactionDetail",
        blockHeight: "blockDetail"
      };

      let name = pathMap[key];
      const is_testnet = net === "testnet";
      if (is_testnet) {
        name += "Test";
      }

      let params = {};
      if (is_testnet) {
        params.net = "testnet";
      }

      if (key === "token") {
        params.contractType = item.type;
        params.tokenName = item.name;
        params.contractHash = item.contract_hash;
      }

      if (key === "ontId") {
        params.ontid = item;
      }

      if (key === "contract") {
        params.contractHash = item.contract_hash;
        params.contractType = item.type ? item.type : "other";
      }

      if (key === "address") {
        params.address = item;
        params.assetName = "ALL";
      }

      if (key === "transaction") {
        params.tx_hash = item;
        params.assetName = "ALL";
      }

      if (key === "blockHeight") {
        params.param = item;
      }

      if (["address", "contract", "token", "ontId"].includes(key)) {
        params = {
          ...params,
          pageSize: 10,
          pageNumber: 1
        };
      }

      this.$router.push({
        name,
        params
      });
      this.$emit("submit");
    }
  },
  created() {
    this.debouncedWatch = debounce(newValue => {
      this.query(newValue);
    }, 600);
  },
  beforeUnmount() {
    this.debouncedWatch.cancel();
  }
};
</script>

<style lang="less" scoped>
.search-tip {
  position: absolute;
  left: 0;
  z-index: 100;
  text-align: left;
  background-color: #fff;
  line-height: initial;
  border-radius: 0px 0px 20px 20px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.08);
  font-family: "Avenir";
}

.search-content {
  max-height: 400px;
  overflow-y: auto;
}

.search-hd {
  padding: 12px 38px;
  font-weight: 800;
  font-size: 18px;
}

.search-bd {
  padding: 12px 38px;
  max-width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    background-color: rgba(250, 250, 250, 0.5);
  }
}

.search-common {
  top: 60px;
  width: 100%;
  .search-hd {
    background: #f9f9f9;
  }
}

.search-simple {
  top: 39px;
  width: 490px;
  z-index: -1;

  &::before {
    content: " ";
    left: 0;
    right: 0;
    display: block;
    background-color: #fafafa;
    height: 20px;
  }
}

@media only screen and (max-width: 1370px) {
  .search-simple {
    left: 150px;
  }
}

.search-mobile {
  .search-content {
    max-height: 40vh;
    overflow-y: auto;
  }
}

.hash {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 1;
}

.token {
  display: flex;
  column-gap: 10px;
  align-items: center;
  .token-no-logo {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #1067bb;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Avenir;
    font-size: 14px;
    flex-shrink: 0;
  }
}

.f-b {
  font-weight: 600;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/common/searchTip.vue